export default __webpack_public_path__ + "static/media/Hokky1jijiji.6fd43a82.gif";